import { keychainService } from './keychainService';
import { App } from '@capacitor/app';
/**
 * Activity Heartbeat Service
 * Sends a heartbeat + timezone to the backend when the app opens.
 * Used for inactivity reminders and timezone-aware notifications.
 */

const API_URL = process.env.REACT_APP_BACKEND_URL || 'https://worthly-backend-production.up.railway.app';

export const sendActivityHeartbeat = async () => {
  try {
    const sessionToken = await keychainService.getItem('session_token');
    if (!sessionToken) return;

    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    // Read the installed app version from Capacitor. Falls back gracefully
    // if the plugin isn't available (e.g. running in a plain web browser).
    let appVersion = null;
    try {
      const info = await App.getInfo();
      appVersion = info?.version || null;
    } catch (err) {
      // Plugin unavailable or web context — just skip the version field.
    }

    const payload = { timezone: userTimezone };
    if (appVersion) payload.app_version = appVersion;

    await fetch(`${API_URL}/api/activity/heartbeat`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${sessionToken}`
      },
      body: JSON.stringify(payload)
    });
  } catch (error) {
    console.log('[heartbeat] Failed:', error.message);
  }
};
